import { CalendarDays } from 'lucide-react'
import type { PeriodSelection } from '../types'

interface PeriodControlProps {
  selection: PeriodSelection
  onChange: (selection: PeriodSelection) => void
}

export function PeriodControl({ selection, onChange }: PeriodControlProps) {
  return (
    <div className="period-control">
      <CalendarDays aria-hidden="true" size={17} strokeWidth={1.8} />
      <label className="sr-only" htmlFor="period-select">Reporting period</label>
      <select
        id="period-select"
        value={selection.key}
        onChange={(event) => onChange({
          key: event.target.value as PeriodSelection['key'],
          from: selection.from,
          to: selection.to,
        })}
      >
        <option value="today">Today</option>
        <option value="7d">Last 7 days</option>
        <option value="30d">Last 30 days</option>
        <option value="custom">Custom range</option>
      </select>
      {selection.key === 'custom' && (
        <div className="custom-range">
          <label>
            <span>From</span>
            <input
              type="date"
              min="2026-01-05"
              max={selection.to ?? '2026-02-03'}
              value={selection.from ?? '2026-01-20'}
              onChange={(event) => onChange({ ...selection, from: event.target.value })}
            />
          </label>
          <label>
            <span>To</span>
            <input
              type="date"
              min={selection.from ?? '2026-01-05'}
              max="2026-02-03"
              value={selection.to ?? '2026-02-03'}
              onChange={(event) => onChange({ ...selection, to: event.target.value })}
            />
          </label>
        </div>
      )}
    </div>
  )
}
